import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigFormScreen } from './ConfigFormScreen';
import { useOgDeviceSettings, useUpdateOgDeviceSettings, } from '@/api/opengater/useSettings';
/** users `admin: device-settings` — base min/max device limits. */
export function OpengaterDevices() {
    const q = useOgDeviceSettings();
    const upd = useUpdateOgDeviceSettings();
    return (_jsx(ConfigFormScreen, { title: "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430", subtitle: "\u0411\u0430\u0437\u043E\u0432\u044B\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F \u043F\u043E \u0447\u0438\u0441\u043B\u0443 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432", capability: "device-settings.write", sections: [
            {
                fields: [
                    { key: 'min_devices', label: 'Минимум устройств', kind: 'int', min: 0 },
                    { key: 'max_devices', label: 'Максимум устройств', kind: 'int', min: 0 },
                ],
            },
        ], data: q.data, warnings: q.data?.warnings, isLoading: q.isLoading, error: q.error, saving: upd.isPending, saveError: upd.error, saved: upd.isSuccess, onSave: (patch) => upd.mutate(patch), onResetFeedback: upd.reset }));
}
